import {
  GROUP_NAME_PEOPLE,
  GROUP_NAME_NATURE,
  GROUP_NAME_FOOD,
  GROUP_NAME_TRAVEL,
  GROUP_NAME_ACTIVITIES,
  GROUP_NAME_OBJECTS,
  GROUP_NAME_SYMBOLS,
  GROUP_NAME_FLAGS,
  GROUP_NAME_RECENTLY_USED,
} from '../../../lib/constants';

export const PROPERTY_DATA_NAME = 'data-name';

export const GROUP_NAMES_ENGLISH = {
  [GROUP_NAME_PEOPLE]: 'smileys & people',
  [GROUP_NAME_NATURE]: 'animals & nature',
  [GROUP_NAME_FOOD]: 'food & drink',
  [GROUP_NAME_TRAVEL]: 'travel & places',
  [GROUP_NAME_OBJECTS]: GROUP_NAME_OBJECTS,
  [GROUP_NAME_ACTIVITIES]: GROUP_NAME_ACTIVITIES,
  [GROUP_NAME_SYMBOLS]: GROUP_NAME_SYMBOLS,
  [GROUP_NAME_FLAGS]: GROUP_NAME_FLAGS,
  [GROUP_NAME_RECENTLY_USED]: 'Recently Used',
};
